<template>
<section :style="bg" :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}, 'section', block.bgcolour, {'has-bg': bg}]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div class="container">
        <div :class="['columns is-variable is-6 is-multiline', {'is-mobile': !is_mobile}, {'animating': block.animated}]">
            <div :class="['column is-still title-column grid-col is-' + (block.title_fullwidth ? '12' : col_size), {'title-fullwidth': block.title_fullwidth}]">
                <div class="inner"><h2 :class="['title', {'has-text-centered': block.title_centred}]">{{block.title}}</h2></div>
            </div>
            <div :class="'column is-still grid-col is-' + (col_size == 4 ? 8 : col_size)" v-if="block.content">
                <div class="inner"><div class="content block-main-content" ref="blockowncontent" v-html="block.content"></div></div>
            </div>
            <template v-if="block.grids && block.grids.length > 0">
                <GridItem
                    v-for="item, i in block.grids"
                    :key="'grid-' + i"
                    :col_size="col_size"
                    :is_still="!is_mobile && !block.content && i < (col_size == 4 ? 2 : 1)"
                    :item="item"
                />
            </template>
        </div>
        <div :class="['cta has-text-centered', {'has-margin-top': bg}]" v-if="block.cta && block.cta.button">
            <CTALink :link_data="block.cta" />
        </div>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
import GridItem from './elements/GridItem';
export default {
    name        :   'GridBlock',
    mixins      :   [ BlockCommons ],
    components  :   { GridItem },
    data()
    {
        return {
            is_mobile   :   false,
            col_size    :   4
        }
    },
    computed    :   {
        bg()
        {
            if (this.block && this.block.bg_image) {
                console.log(`background-image: url(${this.block.bg_image.url});`);
                return `background-image: url(${this.block.bg_image.url});`;
            }

            return null;
        }
    },
    mounted()
    {
        this.$bus.$on('onWindowSize', this.handle_window_resize);
        this.$nextTick().then(() => {
            $(window).resize();
            if (this.$refs.blockowncontent) {
                this.HandleContentedLinks(this.$refs.blockowncontent, this)
            }
        });
    },
    beforeDestroy()
    {
        this.$bus.$off('onWindowSize', this.handle_window_resize);
    },
    methods :   {
        handle_window_resize(width)
        {
            this.is_mobile  =   width < 768;
            if (width >= 768 && width < 960) {
                this.col_size   =   6;
            } else {
                this.col_size   =   4;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/GridBlock.vue